module.exports = __webpack_public_path__ + "img/wou_logo.4630c031.png";